import AuthChatInput from '../../../components/shared/chat-input/AuthChatInput';
import ChatContent from '../../ai-auth/chat/ChatContent';

const RegisterStaff = () => {
	return (
		<div className='mt-auto max-w-full w-full'>
			<div className='my-2 flex flex-col'>
				<div className='w-full bg-primary-default py-2 px-5 flex flex-wrap items-center text-white text-[15px]'>
					<img alt='avatar' className='mr-4' src='/svg/auth/avatar.svg' />
					Rebecca @Orient Express La Dolce Vita
				</div>
				<ChatContent type='sign-up' />
				<div className='p-5 border border-gray-100'>
					<AuthChatInput type='sign-up' />
				</div>
			</div>
		</div>
	)
}

export default RegisterStaff;